// extracted by mini-css-extract-plugin
module.exports = {"header":"g5","headerBg":"g6"};